import React, { FC } from 'react'
import { useSpDeliveryReportController } from './hooks/useSpDeliveryReportController'
import DeliveryReportPhoneInput from './components/DeliveryReportPhoneInput'
import InvalidUidScreen from './components/InvalidUidScreen'
import styles from './style.module.css'

const SpDeliveryReportPage: FC = () => {
  const { pageState, errorMessage, initialPhone, handleSubmit, handleClose } =
    useSpDeliveryReportController()

  if (pageState === 'loading') return null
  if (pageState === 'invalid_uid') return <InvalidUidScreen />
  if (pageState === 'network_error') {
    return (
      <div className={styles.invalidUidScreen}>
        {/* TODO: design.md 確定後にコピー・デザインを更新 */}
        <p className={styles.invalidUidMessage}>通信エラーが発生しました。再度お試しください。</p>
      </div>
    )
  }

  return (
    <DeliveryReportPhoneInput
      initialPhone={initialPhone}
      errorMessage={errorMessage}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  )
}

export default SpDeliveryReportPage
